import React from 'react';
import { readStoredAccent, readStoredTheme } from 'design/StatementContext';

/**
 * A full-screen page outside the app shell: sign-in, the auth callback, the
 * first load, a crash. It reads the stored theme and accent itself because
 * some of these render before `StatementProvider` exists (the error boundary
 * sits above the whole app), and a dark user should not get a white flash.
 */
export const StandalonePage: React.FC<{ title?: string; children: React.ReactNode }> = ({ title, children }) => (
  <div className="st-root st-standalone" data-theme={readStoredTheme() ? 'dark' : 'light'} data-accent={readStoredAccent()}>
    {title ? (
      <div className="st-card st-standalone-card">
        <h1 className="st-display st-standalone-title">{title}</h1>
        {children}
      </div>
    ) : (
      children
    )}
  </div>
);

export const Spinner: React.FC = () => <span className="st-spinner" role="status" aria-label="Loading" />;

export const PageLoading: React.FC<{ label?: string }> = ({ label }) => (
  <StandalonePage>
    <div className="st-standalone-loading">
      <Spinner />
      {label && <span className="st-muted">{label}</span>}
    </div>
  </StandalonePage>
);
